module.exports = __webpack_public_path__ + "img/jhjs.ff396463.jpg";